import Parse from 'parse/dist/parse.min.js';
import { handleParseError } from '../../../errorhandling';

let localSubscription = undefined;

// User subscription
function createSubscription(store) {
	let userQuery = new Parse.Query('Widget');
	userQuery.limit(100000)
	userQuery.equalTo("isGlobal", true)
		.find()
		.then((results) => {
			store.dispatch('widgets/set', results)
		})
		.catch((error) => {
			handleParseError(error);
			
		});
	userQuery.subscribe().then((subscription) => {
		localSubscription = subscription;
			
		subscription.on('create', (object) => {
				
			store.dispatch('widgets/insert', object)
		});
		subscription.on('update', (object) => {
				
			store.dispatch('widgets/replace', object)
		});
		subscription.on('enter', (object) => {
				
			store.dispatch('widgets/insert', object)
		});
		subscription.on('leave', (object) => {
				
			store.dispatch('widgets/delete', object)
		});
		subscription.on('delete', (object) => {
				
			store.dispatch('widgets/delete', object)
		});
		subscription.on('close', () => {
				
		});
	})
}

export default function createWidgetsSubscription() {
	return store => {
		if(store.state.currentUser && !localSubscription) {
			createSubscription(store)
		}
		store.subscribe(mutation => {
			if (mutation.type === 'SET_CURRENT_USER') {
				if (!localSubscription) {
					createSubscription(store)
				}
			}
		})
	}
}